import type { IBadgePhase, IPhaseProps } from "./types";

interface IBadgeStatusProps {
  phase: IPhaseProps;
  primaryMsisdn?: string;
  selectedMsisdn?: string;
  phaseType: "ftth" | "mobile";
}

export function getStatusBadge({
  phase,
  phaseType,
  primaryMsisdn,
  selectedMsisdn,
}: IBadgeStatusProps): IBadgePhase | undefined {
  if (selectedMsisdn && phaseType === "mobile") {
    return {
      iconName: "spinner",
      text: "w trakcie realizacji",
    };
  }

  if (primaryMsisdn && phaseType === "mobile") {
    return {
      iconName: "check",
      text: "zamówienie zrealizowane",
    };
  }

  if (phase === "phaseInProgress") {
    return {
      iconName: "spinner",
      text: "w trakcie realizacji",
    };
  }

  if (phase === "phaseResignation") {
    return {
      iconName: "times-circle",
      text: "rezygnacja z usługi",
    };
  }

  if (phase === "phaseModemReturn") {
    return {
      iconName: "undo",
      text: "zwrot modemu w toku",
    };
  }

  if (phase === "phaseCompleted") {
    return {
      iconName: "check",
      text: "zamówienie zrealizowane",
    };
  }

  return undefined;
}
